import ClassicEditor from '@ckeditor/ckeditor5-editor-classic/src/classiceditor'
import axios from '@/axios'
// import CKFinder from '@ckeditor/ckeditor5-ckfinder/src/ckfinder';

import Alignment from '@ckeditor/ckeditor5-alignment/src/alignment'
import Essentials from '@ckeditor/ckeditor5-essentials/src/essentials'
import UploadAdapter from '@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter'
import Autoformat from '@ckeditor/ckeditor5-autoformat/src/autoformat'
import Bold from '@ckeditor/ckeditor5-basic-styles/src/bold'
import Italic from '@ckeditor/ckeditor5-basic-styles/src/italic'
import BlockQuote from '@ckeditor/ckeditor5-block-quote/src/blockquote'

import Heading from '@ckeditor/ckeditor5-heading/src/heading'
import Image from '@ckeditor/ckeditor5-image/src/image'
import ImageResize from '@ckeditor/ckeditor5-image/src/imageresize'
import ImageCaption from '@ckeditor/ckeditor5-image/src/imagecaption'
import ImageStyle from '@ckeditor/ckeditor5-image/src/imagestyle'
import ImageToolbar from '@ckeditor/ckeditor5-image/src/imagetoolbar'
import ImageUpload from '@ckeditor/ckeditor5-image/src/imageupload'
import Link from '@ckeditor/ckeditor5-link/src/link'
import LinkImage from '@ckeditor/ckeditor5-link/src/linkimage'
import List from '@ckeditor/ckeditor5-list/src/list'
import MediaEmbed from '@ckeditor/ckeditor5-media-embed/src/mediaembed'
import Paragraph from '@ckeditor/ckeditor5-paragraph/src/paragraph'
import Table from '@ckeditor/ckeditor5-table/src/table'
import TableToolbar from '@ckeditor/ckeditor5-table/src/tabletoolbar'

function AddClassToAllLinks(editor) {
  // Both the data and the editing pipelines are affected by this conversion.
  editor.conversion.for('downcast').add((dispatcher) => {
    // Links are represented in the model as a "linkHref" attribute.
    // Use the "low" listener priority to apply the changes after the link feature.
    dispatcher.on(
      'attribute:linkHref',
      (evt, data, conversionApi) => {
        const viewWriter = conversionApi.writer
        const viewSelection = viewWriter.document.selection

        // Adding a new CSS class is done by wrapping all link ranges and selection
        // in a new attribute element with a class.
        const viewElement = viewWriter.createAttributeElement(
          'a',
          {
            class: 'ck-link',
          },
          {
            priority: 5,
          }
        )

        if (data.item.is('selection')) {
          viewWriter.wrap(viewSelection.getFirstRange(), viewElement)
        } else {
          viewWriter.wrap(conversionApi.mapper.toViewRange(data.range), viewElement)
        }
      },
      { priority: 'low' }
    )

    // We will convert inserting "paragraph" model element into the model.
    dispatcher.on('insert:image', (evt, data, conversionApi) => {
      // Remember to check whether the change has not been consumed yet and consume it.
      // console.log(data)
    })
  })
}

export default {
  data() {
    return {
      ckeditor: ClassicEditor,
      ckeditorData: '',
      ckConfig: {
        language: 'ru',
        plugins: [
          // CKFinder,
          Essentials,
          UploadAdapter,
          Autoformat,
          Bold,
          Italic,
          BlockQuote,
          Heading,
          Image,
          ImageCaption,
          ImageStyle,
          ImageToolbar,
          ImageUpload,
          ImageResize,
          Link,
          LinkImage,
          List,
          MediaEmbed,
          Paragraph,
          Table,
          TableToolbar,
          Alignment,
        ],
        extraPlugins: [AddClassToAllLinks],
        mediaEmbed: {
          previewsInData: true,
        },
        image: {
          toolbar: [
            'linkImage',
            'imageTextAlternative',
            '|',
            'imageStyle:alignLeft',
            'imageStyle:full',
            'imageStyle:alignRight',
          ],
          styles: ['full', 'alignLeft', 'alignRight'],
        },
        ckfinder: {
          options: {
            connectorInfo: `token=${localStorage.getItem('user-token')}`,
            connectorPath: 'http://localhost:8080/v1/images/list/ckeditor',
            resourceType: 'Images',
            readOnly: true,
            defaultDisplayFileName: false,
            defaultViewType: 'list',
          },
          onInit: function (finder) {
            finder.request('dialog:info', { msg: 'It works!' })
          },
        },
        toolbar: {
          items: [
            // 'ckfinder',
            'heading',
            '|',
            'bold',
            'italic',
            'link',
            'bulletedList',
            'numberedList',
            'imageUpload',
            'blockQuote',
            'insertTable',
            'mediaEmbed',
            'alignment',
            'undo',
            'redo',
          ],
        },
        // plugins:[Image, PDF, IFrame,]
        // disallowedContent: 'img{width,height}'
        // The configuration of the editor.
      },
      UploadAdapter: function (loader) {
        const self = this
        this.loader = loader
        this.upload = () => {
          const body = new FormData()
          this.loader.file.then((file) => {
            body.append('file', file, file.name)
          })

          const config = {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (evt) => {
              if (evt.lengthComputable) {
                this.loader.uploadTotal = evt.total
                this.loader.uploaded = evt.loaded
              }
            },
          }

          return axios({
            url: '/v1/images',
            method: 'post',
            data: body,
            config: config,
          })
            .then((response) => {
              const data = response.data
              return {
                default: data.url,
              }
            })
            .catch((error) => {
              this.$log.error(error)
            })
        }
        this.abort = () => {}
      },
    }
  },
  methods: {
    setUploader(editor) {
      editor.plugins.get('FileRepository').createUploadAdapter = (loader) =>
        new this.UploadAdapter(loader)
    },
  },
}
